module.exports = {
    methods: {
        readableTime(hh_mm) {
            if (moment(hh_mm, 'hh:mm').format('m') === '0') {
                return moment(hh_mm, 'hh:mm').format('a h시');
            } else {
                return moment(hh_mm, 'hh:mm').format('a h시 m분');
            }

        },
        justTime(hh_mm){
            if(moment(hh_mm, 'hh_mm').format('m') === '0'){
                return moment(hh_mm, 'hh:mm').format('h시');
            }else{
                return moment(hh_mm, 'hh:mm').format('h시 m분');
            }
        }
    }
};
